import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMapModule } from 'src/app/modules/ngx-map/ngx-map.module';
import { PermitsComponent } from './permits.component';
import { PermitsTableComponent } from './components/permits-table/permits-table.component';
import { PermitSummaryFilterPipe } from './pipes/permit-summary-filter.pipe';

@NgModule({
  declarations: [PermitsComponent, PermitsTableComponent, PermitSummaryFilterPipe],
  imports: [
    CommonModule,
    RouterModule.forChild([
      { path: 'review-permits', component: PermitsComponent },
      { path: 'pending-permits', component: PermitsComponent }
    ]),
    NgxMapModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [PermitsComponent, PermitsTableComponent]
})
export class PermitsModule { }
